import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "h-100 w-100 d-flex"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border m-auto text-light",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventDetailModal = _resolveComponent("EventDetailModal")!
  const _component_EventGroup = _resolveComponent("EventGroup")!
  const _component_EventsFullPage = _resolveComponent("EventsFullPage")!

  return (_ctx.eventSearch)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(_component_EventDetailModal, {
          id: "homeEventDetailModal",
          event: _ctx.currEvent
        }, null, 8, ["event"]),
        (_ctx.eventSearch.eventGroups.length !== 1)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.eventSearch.eventGroups, (eventGroup) => {
              return (_openBlock(), _createBlock(_component_EventGroup, {
                key: _ctx.getCategoryId(eventGroup.category),
                onSelectEvent: _ctx.selectEvent,
                "event-group": eventGroup,
                "single-line": true
              }, null, 8, ["onSelectEvent", "event-group"]))
            }), 128))
          : (_openBlock(), _createBlock(_component_EventsFullPage, {
              key: 1,
              onSelectEvent: _ctx.selectEvent,
              "event-group": _ctx.eventSearch.eventGroups[0]
            }, null, 8, ["onSelectEvent", "event-group"]))
      ], 64))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}